/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_HomeInputs */

const en_cc_home = /** @type {(inputs: Cc_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to KerjaBareng`)
};

const id_cc_home = /** @type {(inputs: Cc_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke KerjaBareng`)
};

/**
* | output |
* | --- |
* | "Back to KerjaBareng" |
*
* @param {Cc_HomeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_home = /** @type {((inputs?: Cc_HomeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_HomeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_home(inputs)
	return en_cc_home(inputs)
});